module.exports = __webpack_public_path__ + "img/P150T_weapon_147.38abb876.png";